import { Page } from '@/components/layout/Page';
import { PAGE_PERSONA } from '@/features/decisions/config/personaContext';
import { useActivePersonaContext } from '@/features/decisions/hooks/useActivePersonaContext';
import { useReplenishmentQueue } from '@/features/decisions/hooks/useReplenishmentQueue';
import { useReplenishmentSummary } from '@/features/decisions/hooks/useReplenishmentSummary';

import { ActivePersonaContextSettings } from '../canvas/ActivePersonaContextSettings';
import { ActivePlanningKpis } from './ActivePlanningKpis';
import { ReplenishmentQueueTable } from './ReplenishmentQueueTable';

export function ActivePlanningContainer() {
  const { scenarioRunId, runId, refExperimentId, experimentIds, periodFrom, periodTo, setUrlParam } =
    useActivePersonaContext(PAGE_PERSONA.activePlanning);
  const experimentId = experimentIds[0] ?? '';

  const summary = useReplenishmentSummary({
    scenarioRunId,
    runId,
    refExperimentId,
    experimentId,
    period: periodTo,
  });

  const queue = useReplenishmentQueue({
    scenarioRunId,
    runId,
    refExperimentId,
    experimentIds: [experimentId],
    period: periodTo,
  });

  return (
    <Page
      subheader="Per-SKU-per-site Incumbent vs Keystone comparison. Driven by the Scenario &amp; Policies settings (gear, top-right)."
      actions={
        <ActivePersonaContextSettings
          scenarioRunId={scenarioRunId}
          runId={runId}
          refExperimentId={refExperimentId}
          experimentId={experimentId}
          periodTo={periodTo}
          onCommit={setUrlParam}
        />
      }
    >
      <div className="space-y-6">
        <ActivePlanningKpis
          summary={summary.summary}
          metric={summary.resolved?.metric}
          isLoading={summary.isLoading}
          error={summary.error}
          period={periodTo}
          refExperimentId={refExperimentId}
          experimentId={experimentId}
        />

        <ReplenishmentQueueTable
          groups={queue.groups}
          persona={{ scenarioRunId, runId, refExperimentId, experimentId, periodFrom, periodTo }}
          resolved={queue.resolved}
          pageInfo={queue.pageInfo}
          primaryCompareId={queue.primaryCompareId}
          period={periodTo}
          page={queue.page}
          setPage={queue.setPage}
          pageSize={queue.pageSize}
          isLoading={queue.isLoading}
          error={queue.error}
          elapsedMs={queue.elapsedMs}
        />
      </div>
    </Page>
  );
}
